export default __webpack_public_path__ + "static/media/google-play-badge.98071f07.png";